<script lang="ts">
  import { onMount } from 'svelte';
  import initScene from '../scene';

  let sceneRootRef = $state<HTMLElement>();

  onMount(() => {
    if (sceneRootRef) initScene(sceneRootRef);
  });
</script>

<div bind:this={sceneRootRef}></div>

<style lang="scss">
  div {
    width: 100vw;
    height: 100vh;
    display: flex;
    overflow: hidden;
  }
</style>
